

import { Input } from "@/components/ui/input";
import SearchIcon from "./SearchIcon";

interface SearchBarProps {
  onSearchChange?: ( e: React.ChangeEvent<HTMLInputElement>) => void;
  searchQuery?: string;
  handleKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  handleFocus?: () => void;
}

export function SearchBar({ onSearchChange, searchQuery, handleKeyDown, handleFocus }: SearchBarProps) {
  
  return (
    <div className="relative flex items-center w-full">
      <div className="absolute left-[11px] pointer-events-none">
        <SearchIcon width={17} height={17} color="rgba(0, 0, 0, 0.50)" />
      </div>
      <Input
        type="text"
        placeholder="search"
        value={searchQuery}
        onChange={onSearchChange}
        onKeyDown={handleKeyDown}
        onFocus={handleFocus}
        className="w-full pl-[2rem] bg-search-bg border-search-border rounded-[5px] text-[15px] font-lexend font-light tracking-[-0.22px] capitalize placeholder:text-search-text placeholder:capitalize"
      />
    </div>
  );
}
